import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef, useState } from 'react';
import { AppFooter, BaseContainer, BouncingArrow, FooterLi } from './components/styled';
import { useWindowSize } from './helpers';
import { About, Contact, Home, Portfolio } from './pages';

import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';

import jmBold from './assets/jm-bold.svg';

function App() {
  const [, height] = useWindowSize();
  const [currentIndex, setCurrentIndex] = useState(0);
  const pages = ['home', 'about', 'portfolio', 'contact'];
  const refs = {};
  const [shouldNavBarStick, setShouldNavBarStick] = useState(false);

  let baseRef = useRef();
  refs.home = useRef();
  refs.intro = useRef();
  refs.about = useRef();
  refs.portfolio = useRef();
  refs.contact = useRef();

  const handleArrowClick = () => {
    const index = (currentIndex + 1) % pages.length;
    if (refs[pages[index]] && refs[pages[index]].current) {
      refs[pages[index]].current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
    setCurrentIndex(index);
  };

  const handleLinkClick = target => {
    const index = pages.findIndex(page => page === target);
    document.getElementById(pages[index]).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
    setCurrentIndex(index);
  };

  return (
    <BaseContainer
      height={height}
      ref={ref => (baseRef = ref)}
      onScroll={e => {
        setCurrentIndex(Math.floor(e.target.scrollTop / height));
        setShouldNavBarStick(baseRef.scrollTop >= height - 50 - 50);
      }}
    >
      <Home
        id={'home'}
        ref={refs['home']}
        height={height}
        shouldNavBarStick={shouldNavBarStick}
        onLinkClicked={handleLinkClick}
        currentPage={pages[currentIndex]}
      />
      <About id={'about'} ref={refs['about']} height={height} />
      <Portfolio id={'portfolio'} ref={refs['portfolio']} height={height} />
      <Contact id={'contact'} ref={refs['contact']} height={height} />
      <AppFooter>
        <div id="short-contact">
          <FooterLi>
            <img src={jmBold} alt="" height="50" width="50" />
          </FooterLi>
          <p>Created by Jamal Moore 2021</p>
          <div>
            <a href="https://twitter.com/jm4l1">
              <TwitterIcon />
            </a>
            <a href="https://www.linkedin.com/in/jamalmoore/">
              <LinkedIcon />
            </a>
            <a href="https://www.instagram.com/jm4l1/">
              <InstagramIcon />
            </a>
            <a href="https://github.com/jm4l1">
              <GitHubIcon />
            </a>
          </div>
        </div>
      </AppFooter>
      {!shouldNavBarStick && (
        <BouncingArrow onClick={handleArrowClick}>
          <FontAwesomeIcon icon={faChevronDown} />
        </BouncingArrow>
      )}
    </BaseContainer>
  );
}

export default App;
